import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SideDrawerComponent } from './side-drawer.component';

@NgModule({
  declarations: [SideDrawerComponent],
  imports: [CommonModule],
  exports: [SideDrawerComponent],
})
export class SideDrawerModule {}
